import { postFactory, getFactory, loadVizFactory } from "./transport";

/* GET */
export const getSelectedIdentifier = getFactory("/api/get-selected-identifier");
export const getActualAge = getFactory("/api/get-actual-age");
export const getActualSex = getFactory("/api/get-actual-sex");
export const getActualRace = getFactory("/api/get-actual-race");
export const getActualEthnicity = getFactory("/api/get-actual-ethnicity");
export const getActualScores = getFactory("/api/get-actual-scores");
export const getActualDiagnosisMask = getFactory("/api/get-actual-diagnosis-mask");
export const getTakenMeasureMask = getFactory("/api/get-taken-measure-mask");
export const getPosteriors = getFactory("/api/get-posteriors");
export const getPredictedMeans = getFactory("/api/get-predicted-means");
export const getPredictedStds = getFactory("/api/get-predicted-stds");
export const getAvailableIdentifiers = getFactory("/api/get-available-identifiers");
export const getAllDiagnosisNames = getFactory("/api/get-all-diagnosis-names");
export const getAllDiagnosisLabels = getFactory("/api/get-all-diagnosis-labels");
export const getAllMeasureNames = getFactory("/api/get-all-measure-names");
export const getDsmAssociations = getFactory("/api/get-dsm-associations");

/* POST */
export const setSelectedIdentifier = postFactory("/api/post-selected-identifier");
export const getDiagnosisCorrelatedMeasures = postFactory("/api/get-diagnosis-correlated-measures");
export const getPriors = postFactory("/api/get-priors");
export const getPopulationMeans = postFactory("/api/get-population-means");
export const getPopulationStds = postFactory("/api/get-population-stds");
export const getTwoDiagnosesCorrelatedMeasures = postFactory("/api/get-two-diagnoses-correlated-measures");
export const getQuantiles = postFactory("/api/get-quantiles");
export const getActualPercentileRanks = postFactory("/api/get-actual-percentile-ranks");
export const getPredictedPercentileRanks = postFactory("/api/get-predicted-percentile-ranks");

// TODO (SID): load viz example
export const getDiagnosisBarChart = loadVizFactory("/api/get-diagnosis-bar-chart");
